module.exports = __webpack_public_path__ + "img/BG.a01f1c00.png";